export const TURN_PAGE_TYPE = {
    TURN_RIGHT: 0,
    TURN_LEFT: 1
}

